<template>
  <div class="center-warp sales">
    <div class="inner warp-page" style="height: fit-content">
      <div class="top-nav">
        <div :class="queryParams.type == 1 ? 'on' : ''" @click="navChange(1)">我的客户</div>
        <div :class="queryParams.type == 2 ? 'on' : ''" @click="navChange(2)">未拜访客户</div>
      </div>
      <div class="center-filter d-flex-between">
        <div class="filter-sort">
          <div v-for="(item,index) in sortList" :class="index == orderIndex ? 'on' : ''" class="filter-sort-item"
               @click="orderChange(index)">{{ item.name }}·
            <span @click.stop="orderSortChange(index)" class="hover-bg">{{ item.param_name[orderSortIndex[index]] }}<i class="iconfont icon-qiehuan"></i></span>
          </div>
        </div>
        <div class="d-flex-center">
          <div style="position: relative">
            <div class="el-dropdown-link filter-drop" @click="openDrop">
              {{ confirmCityVal.length ? '已筛选' : '筛选'}}<i class="iconfont icon-xialaanniu"></i>
            </div>
            <div class="filter-drop-cont" v-if="showDrop">
              <div class="d-flex-between">
                <div class="btn-cancel" @click="showDrop = false">取消</div>
                <div class="btn-ok" @click="handleCitySelect">完成</div>
              </div>
              <div class="area-cont">
                <div class="area-block area-all" :class="!cityVal.length ? 'on' : ''" @click="cityChoose(-1)">不限区域</div>
                <div class="area-block" v-for="(item, index) in cityList" :class="cityVal.indexOf(item.province) != -1 ? 'on' : ''" @click="cityChoose(item.province)" :key="'city' + index">{{ item.province }}</div>
              </div>
            </div>
          </div>
          <div class="filter-input">
            <input placeholder="医生姓名" type="text" v-model="queryParams.keyWords" @keyup.enter="handleQuery">
            <img alt="" src="@/assets/img/base/search.png" style="cursor:pointer" @click="handleQuery">
          </div>
        </div>
      </div>
      <div class="bottom-list-warp" v-loading="loading">
        <div class="doctor-list d-flex-between hover-shadow" v-for="(item, index) in list" :key="index">
          <div class="d-flex-center">
            <img :src="item.head_pic" alt="">
            <div>
              <div class="bottom-data-item-info1">{{item.real_name}}医生</div>
              <div class="bottom-data-item-info2">{{item.province}}{{(item.province && item.city) ? '·' : ''}}{{item.city}}/{{item.organization}}</div>
            </div>
          </div>
          <div class="flex-center-center">
            <div class="doctor-num">
              <div class="doctor-word1">{{item.invite_by_id ? item.invite_by : '未绑定'}}</div>
              <div class="doctor-word2">绑定业务员</div>
            </div>
            <div class="doctor-num">
              <div class="doctor-word1">{{item.mentor_id ? item.mentor_name : '未绑定'}}</div>
              <div class="doctor-word2">绑定导师</div>
            </div>
            <div class="doctor-num">
              <div class="doctor-word1">{{item.member_level ? item.member_level.level_code : ''}}</div>
              <div class="doctor-word2">客户等级</div>
            </div>

            <el-popover :visible-arrow="false" placement="bottom-end" width="132" popper-class="more-menu-popover" trigger="click">
              <div class="more-menu">
                <div @click="goCase(item)"><img src="../../assets/img/sales_data/icon1.png">病例列表</div>
                <div @click="goOrder(item)"><img src="../../assets/img/sales_data/icon2.png">TA的订单</div>
                <div @click="goRecords(item)"><img src="../../assets/img/sales_data/icon3.png">走访记录</div>
                <div v-if="member.member_type == 2 && member.is_salesman_manager" @click="openChange(item)"><img src="../../assets/img/sales_data/icon3.png">变更业务员</div>
              </div>
              <div slot="reference" class="iconfont icon-gengduo"></div>
            </el-popover>
          </div>
        </div>

        <Pagination :total="total" :page.sync="queryParams.page" :last_page="last_page" @pagination="getList" :key="'page' + queryParams.page" />

        <el-dialog :visible.sync="showSalesExchange" custom-class="take-dialog grey-bg" title="业务员变更" width="693px" v-loading="formLoading">
          <el-dialog :visible.sync="showChooseSales" custom-class="take-dialog grey-bg" title="选择业务员" append-to-body width="375px">
            <div class="choose-list">
              <div class="choose-line d-flex-between" v-for="item in groupSalesman" :key="'exchange' + item.id" @click="handleChoose(item)">
                <div class="radio iconfont" :class="chooseSalesman.id == item.id ? 'icon-yixuan':'icon-weixuan'"></div>
                <div class="cg-option-item doctor-list d-flex">
                  <img :src="item.head_pic" alt="">
                  <div>
                    <div class="bottom-data-item-info1">{{item.real_name}}</div>
                    <div class="bottom-data-item-info2">{{item.member_group ? item.member_group.name : ''}}{{item.is_salesman_manager ? '业务经理' : '业务员'}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="take-dialog-bottom">
              <div class="take-dialog-close" @click="showChooseSales = false">取消</div>
              <div class="take-dialog-open" @click="handleConfirm">确定</div>
            </div>
          </el-dialog>
          <div class="cg-line">
            <img :src="salesExchangeData.head_pic" alt="">
            <div class="cg-line-name">{{salesExchangeData.real_name}}医生</div>
            <div class="cg-line-info">{{salesExchangeData.province}}{{(salesExchangeData.province && salesExchangeData.city) ? '·' : ''}}{{salesExchangeData.city}}/{{salesExchangeData.organization}}</div>
          </div>
          <div class="cg-option d-flex-between">
            <div class="cg-option-item">
              <div class="black-14">原业务员</div>
              <div class="doctor-list d-flex">
                <img :src="originalSalesman.head_pic" alt="">
                <div>
                  <div class="bottom-data-item-info1">{{originalSalesman.real_name}}</div>
                  <div class="bottom-data-item-info2">{{originalSalesman.member_group ? originalSalesman.member_group.name : ''}}{{originalSalesman.is_salesman_manager ? '业务经理' : '业务员'}}</div>
                </div>
              </div>
            </div>
            <img class="cg-option-icon" src="@/assets/img/sales_data/change.png" alt="">
            <div class="cg-option-item" @click="showChooseSales = true">
              <div class="black-14">新业务员</div>
              <!-- 回显样式 -->
              <div class="doctor-list d-flex choose-sales-data" v-if="newSalesman.id">
                <img :src="newSalesman.head_pic" alt="">
                <div>
                  <div class="bottom-data-item-info1">{{newSalesman.real_name}}</div>
                  <div class="bottom-data-item-info2">{{newSalesman.member_group ? newSalesman.member_group.name : ''}}{{newSalesman.is_salesman_manager ? '业务经理' : '业务员'}}</div>
                </div>
                <div class="re-c-btn">重新选择</div>
              </div>
              <!-- 回显样式end -->
              <!-- 添加样式 -->
              <div class="cg-option-new d-flex-center" v-else>
                <img src="@/assets/img/sales_data/add.png" alt="">
              </div>
            </div>
          </div>
          <div class="take-dialog-bottom">
            <div class="take-dialog-close" @click="showSalesExchange = false">取消</div>
            <div class="take-dialog-open" @click="submitForm">确定</div>
          </div>
        </el-dialog>

      </div>
    </div>
  </div>
</template>

<script>
import {
  doctorList,
  getGroupSalesman,
  memberInfo,
  biangengSalesman,
} from "@/http/sales_custom";
import { GetAllowShowCity } from "@/http/api";
import Pagination from "@/components/Pagination";

export default {
  name: "index",
  components: { Pagination },
  data() {
    return {
      showDrop: false,
      loading: false,
      list: [],
      total: 0,
      last_page: 0,
      queryParams: {
        page: 1,
        pageSize: 10,
        type: 1,
        keyWords: undefined,
      },
      orderName: "im_chaosong_at",
      orderType: "desc",
      cityList: [],
      cityVal: [],
      confirmCityVal: [],
      salesExchangeData: {},
      showSalesExchange: false,
      showChooseSales: false,
      groupSalesman: [],
      originalSalesman: {},
      chooseSalesman: {},
      newSalesman: {},
      form: {
        member_id: undefined,
        salesman_id: undefined,
      },
      formLoading: false,
      member: {},
      sortList:[
        {
          name: '最新消息',
          param:'im_chaosong_at',
          param_name:['新-旧','旧-新'],
          param_order: ["desc","asc"]
        },
        {
          name: '医生姓名',
          param:'real_name',
          param_name:['A-Z','Z-A'],
          param_order: ["asc","desc"]
        },
        {
          name: '区域',
          param:'province',
          param_name:['A-Z','Z-A'],
          param_order: ["asc","desc"]
        },
        {
          name: '新病例数',
          param:'new_case',
          param_name:['多-少','少-多'],
          param_order: ["desc","asc"]
        }
      ],
      orderIndex:0,
      orderSortIndex:[0,0,0,0],
    };
  },
  mounted() {
    this.member = JSON.parse(localStorage.getItem("member"));
    this.initCity();

    if(this.$route.query.type)this.navChange(this.$route.query.type)
    else this.getList();
  },
  methods: {
    navChange(i) {
      this.queryParams.type = i;
      this.handleQuery();
    },
    getList() {
      this.loading = true;
      //排序
      let orderBy = []
      orderBy.push(this.sortList[this.orderIndex].param)
      orderBy.push(this.sortList[this.orderIndex].param_order[this.orderSortIndex[this.orderIndex]])

      this.queryParams.orderBy = orderBy;
      //地区筛选
      if (this.confirmCityVal) {
        this.queryParams.province = this.confirmCityVal.join(",");
      }

      doctorList(this.queryParams).then((res) => {
        this.list = res.data.data;
        this.total = res.data.total;
        this.last_page = res.data.last_page;
        this.loading = false;
      });
    },
    orderChange(i) {
      this.orderIndex = i
      this.handleQuery()
    },
    orderSortChange(i) {
      this.$set(this.orderSortIndex,i,Math.abs(this.orderSortIndex[i] - 1))
      if(i == this.orderIndex) this.handleQuery()
    },
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    initCity() {
      GetAllowShowCity().then((res) => {
        this.cityList = res.data;
      });
    },
    openDrop(){
      if(this.showDrop){
        this.showDrop = false
        return false
      }
      this.showDrop = true
      this.cityVal = []
      this.confirmCityVal.forEach(item=> this.cityVal.push(item))
    },
    cityChoose(name) {
      if (name == -1) {
        this.cityVal = [];
        return;
      }
      if (this.cityVal.indexOf(name) == -1) {
        this.cityVal.push(name);
      } else {
        this.cityVal.splice(this.cityVal.indexOf(name), 1);
      }
    },
    handleCitySelect() {
      this.showDrop = false;
      this.confirmCityVal = []
      this.cityVal.forEach(item=> this.confirmCityVal.push(item))
      this.handleQuery();
    },
    goCase(row) {
      this.$router.push({
        path: "/mentor_case_management?doctor_id=" + row.id + "&name=" + row.real_name,
      });
    },
    goOrder(row) {
      this.$router.push({
        path: "/bill_center?doctor_id=" + row.id + "&name=" + row.real_name,
      });
    },
    goRecords(row)
    {
      this.$router.push({path: '/sales_custom/visit_records?doctor_id=' + row.id + '&name=' + row.real_name})
    },
    openChange(item) {
      this.initForm();
      this.form.member_id = item.id;
      this.salesExchangeData = item;
      this.showSalesExchange = true;
      this.formLoading = true;
      memberInfo({ id: item.invite_by_id }).then((res) => {
        this.originalSalesman = res.data;
        this.formLoading = false;
      });
      this.getSalesmanList();
    },
    getSalesmanList() {
      getGroupSalesman().then((res) => {
        this.groupSalesman = res.data;
      });
    },
    handleChoose(item) {
      this.chooseSalesman = item;
    },
    handleConfirm() {
      this.newSalesman = this.chooseSalesman;
      this.form.salesman_id = this.chooseSalesman.id;
      this.showChooseSales = false;
    },

    initForm() {
      this.form = {
        member_id: undefined,
        salesman_id: undefined,
      };
      this.originalSalesman = {};
      this.chooseSalesman = {};
      this.newSalesman = {};
    },
    submitForm() {
      if (!this.form.member_id) {
        return this.$message.error("医生不能为空");
      }
      if (!this.form.salesman_id) {
        return this.$message.error("新业务员不能为空");
      }
      if (this.formLoading) {
        return;
      }
      this.formLoading = true;
      biangengSalesman(this.form)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
          } else {
            this.$message.error(res.message[0] ? res.message[0] : "修改失败");
          }
          this.formLoading = false;
          this.showSalesExchange = false;
          this.getList();
        })
        .catch(() => {
          this.formLoading = false;
          this.getList();
        });
    },
  },
};
</script>

<style scoped src="../../assets/css/sales_data.css">
</style>
<style>
.more-menu-popover {
  padding: 4px 5px;
  border-radius: 10px;
}
</style>
